const isValidMobilePhone = (phone) => {
  // Accepte tous les numéros sénégalais commençant par 7[0-9] (70-79) ou 3[03][98]
  // Formats acceptés: 771234567, +221771234567, 00221771234567
  const validMobilePhoneRegEx =
    /^((\+221|00221)?)((7[0-9][0-9]{7})|(3[03][98][0-9]{6}))$/;
  return validMobilePhoneRegEx.test(phone);
};

export default isValidMobilePhone;
